import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import certificateBG from "../../../../../../../assets/media/images/certificate-Images/CertificateBG.png";
import styled from "styled-components";
import SchoolPrintHeader3 from "app/components/common/SchoolPrintHeader3";
import CertificateContentLabel from "app/components/common/CertificateContentLabel";
import {
  CertificateBottomDetails,
  CertificateHeaderDetails,
  ContentOfCertificate,
} from "../utils/CertificateHelper";

const BonafideCertificatePrint = ({
  studentData,
  color,
  printRef,
  showHeaderDetails = true,
}) => {
  return (
    <Wrapper ref={printRef}>
      <Box
        style={{
          width: "1056px",
          height: "816px",
          backgroundImage: `url(${certificateBG})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundBlendMode: "normal",
          backgroundRepeat: "no-repeat",
        }}
        sx={{
          alignSelf: "center",
          margin: "10px",
        }}
      >
        <Stack direction="row" justifyContent="center" height={"213px"}>
          <SchoolPrintHeader3 />
        </Stack>
        <Divider
          sx={{
            backgroundColor: "#000",
            height: "1px",
            width: "91%",
            margin: "0 auto",
            alignSelf: "center",
          }}
        />

        {/* title of the certificate */}
        <Stack direction="row" justifyContent="center" marginTop={1}>
          <Box>
            <Box className="heading">Bonafide Certificate</Box>
          </Box>
        </Stack>
        {/* certificate label */}
        <Stack direction="row" justifyContent="center">
          <CertificateContentLabel contentTittle={"TO WHOM IT MAY CONCERN"} />
        </Stack>

        {/* header of the certificate */}
        {showHeaderDetails && <CertificateHeaderDetails value={studentData} />}

        {/* content for certificate */}
        <Stack
          direction="row"
          justifyContent="center"
          sx={{
            marginTop: 3,
            width: "88%",
            height: "260px",
            alignSelf: "center",
            alignItems: "center",
            marginLeft: "6%",
          }}
        >
          <ContentOfCertificate
            certificateType={"bonafied"}
            studentData={studentData}
          />
        </Stack>

        {/* bottom date */}
        <CertificateBottomDetails />
      </Box>
    </Wrapper>
  );
};

export default BonafideCertificatePrint;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  .heading {
    font-weight: 700;
    font-size: 38px;
  }
  .sub-heading {
    font-weight: 700;
    font-size: 10px;
  }
  .content {
    font-size: 20px;
    alingself: center;
  }
  .content-bold {
    font-weight: 700;
    font-size: 16px;
  }
  .content-italic {
    font-style: italic;
    font-size: 10px;
  }
  .content-underline {
    text-decoration: underline;
    font-size: 10px;
  }
  .content-uppercase {
    text-transform: uppercase;
    font-size: 10px;
  }

  @media (max-width: 768px) {
    .heading {
      font-size: 20px;
    }
    .sub-heading {
      font-size: 8px;
    }
    .content {
      font-size: 10px;
    }
    .content-bold {
      font-size: 8px;
    }
    .content-italic {
      font-size: 8px;
    }
    .content-underline {
      font-size: 8px;
    }
    .content-uppercase {
      font-size: 8px;
    }
  }
`;
